import EloSettingsCard from "../pricing-management/components/EloSettingsCard";

export default function EloSettingsPage() {
    return <EloSettingsCard />;
}
